(() => {
  const root = document.querySelector('[data-md-chat]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const KEY = {
    state: 'ovxs-chat-state',
    time: 'ovxs-chat-time',
    shown: 'ovxs-chat-shown',
    views: 'ovxs-chat-views',
    dismissed: 'ovxs-chat-dismissed-until',
    done: 'ovxs-chat-done',
    variant: 'ovxs-chat-variant',
    session: 'ovxs-chat-session',
    memory: 'ovxs-chat-memory',
  };
  const DAY = 86400000;

  const read = (area, key) => {
    try {
      return window[area].getItem(key);
    } catch (error) {
      return null;
    }
  };
  const write = (area, key, value) => {
    try {
      window[area].setItem(key, value);
    } catch (error) {}
  };

  const cfg = root.dataset;
  const endpoint = cfg.endpoint;
  const aiEnabled = cfg.ai === 'true';
  const phone = window.matchMedia('(max-width: 599px)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  let variant = 'a';
  let delay = (Number(cfg.delay) || 210) * 1000;
  const delayB = Number(cfg.delayB) || 0;
  const idleMs = (Number(cfg.idle) || 0) * 1000;
  if (delayB > 0) {
    variant = read('localStorage', KEY.variant);
    if (variant !== 'a' && variant !== 'b') {
      variant = Math.random() < 0.5 ? 'a' : 'b';
      write('localStorage', KEY.variant, variant);
    }
    if (variant === 'b') delay = delayB * 1000;
  }

  const track = (name, properties = {}, options = {}) => {
    const detail = { ...properties, chat_variant: variant };
    if (typeof window.ovxsTrack === 'function') window.ovxsTrack(name, detail, options);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...detail });
    }
  };

  const launcher = root.querySelector('.md-chat__launcher');
  const panel = root.querySelector('.md-chat__panel');
  const log = root.querySelector('[data-md-chat-log]');
  const replies = root.querySelector('[data-md-chat-replies]');
  const contact = root.querySelector('[data-md-chat-contact]');
  const contactError = root.querySelector('[data-md-chat-error]');
  const composer = root.querySelector('[data-md-chat-composer]');
  const input = composer.querySelector('textarea');
  const handoffButton = root.querySelector('[data-md-chat-handoff]');

  const STEPS = [
    {
      slot: 'intent',
      text: cfg.greeting,
      replies: ['New Shopify store', 'Redesign', 'Moving to Shopify', 'Brand', 'Business website', 'Just browsing'],
    },
    { slot: 'website', text: "What's your current site? Paste the address, or skip this one.", replies: ["Don't have one yet", 'Skip'] },
    { slot: 'timeline', text: 'When would you like this live?', replies: ['ASAP', '1–3 months', 'Later'] },
    { slot: 'budget', text: 'Roughly what budget do you have in mind?', replies: ['Under $3k', '$3–10k', '$10k+', 'Monthly plan', 'Not sure yet'] },
  ];

  const AUDIT_TEXT = `The video audit is a 10–15 minute recorded walkthrough of your site, ending with three ranked fixes. No logins and no call, delivered within 3 working days. It's $99, credited in full if you start a project within 60 days. ${cfg.auditUrl}`;
  const PRICE_TEXT =
    'Moving to Shopify starts at $1,500, new Shopify stores at $3,000 and fully custom builds at $6,500. Opening your first Shopify store? There is a $247/month plan with a $500 setup. Full details: /pages/services#pricing';
  const CANNED = {
    'see prices': PRICE_TEXT,
    'what does it cost?': PRICE_TEXT,
    'how the audit works': AUDIT_TEXT,
    'explain the audit': AUDIT_TEXT,
  };
  const owner = cfg.owner || 'Rammy';
  const TALK = `Talk to ${owner}`;
  const PERSON = TALK.toLowerCase();
  const EMAIL_INSTEAD = 'leave my email instead';
  const isPerson = (text) => text === PERSON || text === 'talk to a person';

  const TZ_LABEL = {
    'America/New_York': 'ET',
    'America/Chicago': 'CT',
    'America/Denver': 'MT',
    'America/Los_Angeles': 'PT',
  };
  const WORK_DAYS = { mon_fri: [1, 2, 3, 4, 5], mon_sat: [1, 2, 3, 4, 5, 6], every_day: [0, 1, 2, 3, 4, 5, 6] };
  const zoneParts = (date, timeZone) =>
    Object.fromEntries(
      new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit', weekday: 'long', hourCycle: 'h23' })
        .formatToParts(date)
        .map((part) => [part.type, part.value]),
    );

  const backLabel = (opens) => {
    const zone = cfg.storeTz || 'America/New_York';
    const then = zoneParts(opens, zone);
    const today = zoneParts(new Date(), zone);
    const dayDiff = Math.round((Date.UTC(then.year, then.month - 1, then.day) - Date.UTC(today.year, today.month - 1, today.day)) / 86400000);
    const hour = Number(then.hour) % 24;
    const minute = Math.round(Number(then.minute) / 5) * 5;
    const time = `${hour % 12 || 12}${minute && minute < 60 ? `:${String(minute).padStart(2, '0')}` : ''}${hour < 12 ? 'am' : 'pm'}`;
    const when = dayDiff <= 0 ? 'at' : dayDiff === 1 ? 'tomorrow at' : `${then.weekday} at`;
    return `${when} ${time}${TZ_LABEL[zone] ? ` ${TZ_LABEL[zone]}` : ''}`;
  };

  const presence = () => {
    if (cfg.presence === 'online') return { online: true, text: `${owner}'s around now`, back: '' };
    if (cfg.presence === 'away') return { online: false, text: `${owner}'s away right now`, back: '' };
    const tz = cfg.tz || 'Asia/Kolkata';
    const start = Number(cfg.hoursStart);
    const end = Number(cfg.hoursEnd);
    const days = WORK_DAYS[cfg.days] || WORK_DAYS.every_day;
    let day;
    let hour;
    try {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
          .formatToParts(new Date())
          .map((part) => [part.type, part.value]),
      );
      day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
      hour = (Number(parts.hour) % 24) + Number(parts.minute) / 60;
    } catch (error) {
      return { online: false, text: `${owner} follows up personally`, back: '' };
    }
    if (days.includes(day) && hour >= start && hour < end) return { online: true, text: `${owner}'s around now`, back: '' };
    let ahead = -1;
    if (days.includes(day) && hour < start) ahead = 0;
    else {
      for (let next = 1; next <= 7; next += 1) {
        if (days.includes((day + next) % 7)) {
          ahead = next;
          break;
        }
      }
    }
    const back = ahead < 0 ? '' : backLabel(new Date(Date.now() + (ahead * 24 + start - hour) * 3600000));
    return { online: false, text: back ? `${owner}'s back ${back}` : `${owner}'s away right now`, back };
  };
  const FINE = "i'm fine, thanks";
  const CARRY_ON = 'Yes, carry on';
  const START_FRESH = 'Start fresh';
  const EMAIL_CHIP = 'Leave my email instead';
  const FORM_HELP = { text: 'Stuck on a question? I can go through the form with you.', replies: ['Explain the audit', TALK, "I'm fine, thanks"] };

  const pageContext = () => {
    const where = location.pathname.replace(/\/$/, '') || '/';
    const template = cfg.template || '';
    const title = (cfg.pageTitle || '').trim();
    if (document.querySelector('#OvxsAuditForm') || /^\/pages\/request-audit$/.test(where)) return { kind: 'audit', title };
    if (/^\/pages\/(services|pricing)$/.test(where)) return { kind: 'pricing', title };
    if (/^\/blogs\/case-studies\/./.test(where) || /case-study/.test(template)) return { kind: 'case_study', title };
    if (/^\/pages\/service\/./.test(where) || /^metaobject/.test(template)) return { kind: 'service', title };
    if (/^\/blogs\/[^/]+\/./.test(where)) return { kind: 'blog', title };
    return { kind: 'default', title: '' };
  };

  const opener = (page) => {
    if (page.kind === 'audit') return FORM_HELP;
    if (page.kind === 'pricing') return { text: 'Want help working out which option fits?', replies: ['New Shopify store', 'Moving to Shopify', 'Already on Shopify', 'Monthly plan'] };
    if (page.kind === 'case_study') return { text: 'Want something like this for your store?', replies: ['Yes, tell me more', 'What would it cost?', 'Just reading'] };
    if (page.kind === 'service' && page.title) return { text: `Questions about ${page.title}? I can help you work out if it fits your store.`, replies: ['Is it right for me?', 'What does it cost?', 'See examples'] };
    if (page.kind === 'blog') return { text: 'Hope the read is useful. If it raises a question about your own store, ask me here.', replies: ['I have a question', 'Just reading'] };
    return null;
  };

  const MEMORY_DAYS = 60;
  const recall = () => {
    try {
      const memory = JSON.parse(read('localStorage', KEY.memory) || 'null');
      if (!memory || !memory.summary || !memory.slots || Date.now() - Number(memory.at) > MEMORY_DAYS * 86400000) return null;
      return memory;
    } catch (error) {
      return null;
    }
  };
  const remember = (summary) => {
    if (!summary || !state.slots.intent || /brows|just reading/i.test(state.slots.intent)) return;
    const slots = Object.fromEntries(['intent', 'details', 'website', 'timeline', 'budget'].map((key) => [key, String(state.slots[key] || '').slice(0, 200)]));
    write('localStorage', KEY.memory, JSON.stringify({ summary: summary.slice(0, 60), slots, at: Date.now() }));
  };
  const forget = () => {
    try {
      window.localStorage.removeItem(KEY.memory);
    } catch (error) {}
  };

  const FRUSTRATED = /(not what i asked|that'?s (wrong|not right|incorrect)|you'?re wrong|not helpful|doesn'?t help|didn'?t answer|not answering|you'?re not listening|useless|pointless|annoying|frustrat|ridiculous|already (told|said|asked))/i;
  const HUMAN = /\b(human|real person|actual person|someone real|a person|talk to (someone|somebody|rammy)|speak (to|with) (someone|somebody|rammy))\b/i;
  const normalize = (text) => text.toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, '').replace(/\s+/g, ' ').trim();
  const frustratedBy = (text) => {
    const earlier = state.messages.filter((item) => item.role === 'user').slice(0, -1);
    const said = normalize(text);
    if (said.length > 8 && earlier.some((item) => normalize(item.content) === said)) return true;
    if (FRUSTRATED.test(text)) return true;
    return HUMAN.test(text) && earlier.some((item) => HUMAN.test(item.content) || isPerson(item.content.toLowerCase()));
  };

  const fresh = () => ({
    messages: [],
    slots: { intent: '', details: '', website: '', timeline: '', budget: '' },
    replies: [],
    awaiting: '',
    mode: aiEnabled ? 'ai' : 'scripted',
    trigger: '',
    browsing: false,
    contact: false,
    sent: false,
    finale: false,
    open: false,
    name: '',
  });

  let state = fresh();
  try {
    const saved = JSON.parse(read('sessionStorage', KEY.state) || 'null');
    if (saved && Array.isArray(saved.messages)) state = { ...state, ...saved, slots: { ...state.slots, ...saved.slots } };
  } catch (error) {}
  const save = () => write('sessionStorage', KEY.state, JSON.stringify(state));

  let session = read('sessionStorage', KEY.session) || '';
  if (!/^[A-Za-z0-9_-]{8,80}$/.test(session)) {
    session = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    write('sessionStorage', KEY.session, session);
  }

  let busy = false;
  let rendered = false;

  const sameSite = (href) => {
    try {
      const url = new URL(href, location.origin);
      return url.origin === location.origin ? url.pathname + url.search + url.hash : null;
    } catch (error) {
      return null;
    }
  };

  const fillText = (node, text) => {
    const pattern = /(https?:\/\/[^\s]+|\/(?:pages|blogs|policies|collections|products)\/[^\s,;)]*)/g;
    let last = 0;
    for (const match of text.matchAll(pattern)) {
      let raw = match[0];
      const trailing = raw.match(/[.,!?:]+$/);
      if (trailing) raw = raw.slice(0, -trailing[0].length);
      const href = sameSite(raw);
      node.append(text.slice(last, match.index));
      if (href) {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = raw.replace(/^https?:\/\/[^/]+/, '') || raw;
        node.append(link);
      } else {
        node.append(raw);
      }
      last = match.index + raw.length;
    }
    node.append(text.slice(last));
  };

  const handoffLinks = () => {
    const wrap = document.createElement('div');
    wrap.className = 'md-chat__actions';
    if (cfg.whatsapp) {
      const text = encodeURIComponent(`Hi ${owner}, I was just chatting with ${cfg.name || 'Ovi'} on your website.`);
      const whatsapp = actionLink('Message on WhatsApp', `https://wa.me/${cfg.whatsapp}?text=${text}`, 'chat', true, { target: '_blank', rel: 'noopener' });
      whatsapp.addEventListener('click', () => track('chat_handoff_clicked', { channel: 'whatsapp' }, { upgrade: true }));
      wrap.append(whatsapp);
    }
    if (cfg.bookingUrl) {
      const extra = { 'data-md-booking': '', target: '_blank', rel: 'noopener' };
      if ('bookingCalendly' in cfg) extra['data-md-booking-calendly'] = '';
      const call = actionLink('Book a quick call', cfg.bookingUrl, 'calendar_today', !cfg.whatsapp, extra);
      call.addEventListener('click', () => track('chat_handoff_clicked', { channel: 'call' }));
      wrap.append(call);
    }
    return wrap;
  };

  const bubble = (message) => {
    const node = document.createElement('div');
    node.className = `md-chat__msg md-chat__msg--${message.role === 'user' ? 'user' : 'bot'}`;
    if (message.role === 'user') node.textContent = message.content;
    else fillText(node, message.content);
    return node;
  };

  const rate = (message, rating, row) => {
    const index = state.messages.indexOf(message);
    if (index < 0) return;
    message.rating = message.rating === rating ? '' : rating;
    row.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rating === message.rating)));
    save();
    track('chat_feedback', { rating: message.rating || 'cleared' });
    fetch(`${endpoint}/chat/feedback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ session, index, text: message.content, rating: message.rating || null }),
    }).catch(() => {});
  };

  const rateRow = (message) => {
    const row = document.createElement('div');
    row.className = 'md-chat__rate';
    [
      ['up', 'thumb_up', 'Helpful'],
      ['down', 'thumb_down', 'Not helpful'],
    ].forEach(([rating, icon, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'md-chat__rate-button';
      button.dataset.rating = rating;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(message.rating === rating));
      const glyph = document.createElement('span');
      glyph.className = 'md-icon';
      glyph.setAttribute('aria-hidden', 'true');
      glyph.translate = false;
      glyph.textContent = icon;
      button.append(glyph);
      button.addEventListener('click', () => rate(message, rating, row));
      row.append(button);
    });
    return row;
  };

  const nodesFor = (message) => {
    const nodes = [bubble(message)];
    if (message.handoff) nodes.push(handoffLinks());
    if (message.ai) nodes.push(rateRow(message));
    return nodes;
  };

  const actionLink = (label, href, icon, filled, extra = {}) => {
    const link = document.createElement('a');
    link.className = `md-button md-button--${filled ? 'filled' : 'tonal'}`;
    link.href = href;
    const glyph = document.createElement('span');
    glyph.className = 'md-icon';
    glyph.setAttribute('aria-hidden', 'true');
    glyph.translate = false;
    glyph.textContent = icon;
    link.append(glyph, label);
    Object.entries(extra).forEach(([name, value]) => link.setAttribute(name, value));
    return link;
  };

  const finale = () => {
    const wrap = document.createElement('div');
    wrap.className = 'md-chat__actions';
    const score = state.score || (state.slots.budget === '$10k+' ? 'hot' : 'warm');
    const hot = score === 'hot';
    if (score === 'cold') {
      const work = actionLink('See our work', '/blogs/case-studies', 'arrow_outward', false);
      work.addEventListener('click', () => track('chat_cta_clicked', { cta: 'work' }));
      wrap.append(work);
      return wrap;
    }
    const audit = actionLink('Book the $99 video audit', cfg.auditUrl, 'arrow_outward', !hot || !cfg.bookingUrl);
    audit.addEventListener('click', () => track('chat_cta_clicked', { cta: 'audit' }));
    const links = [audit];
    if (cfg.bookingUrl) {
      const extra = { 'data-md-booking': '', target: '_blank', rel: 'noopener' };
      if ('bookingCalendly' in cfg) extra['data-md-booking-calendly'] = '';
      const call = actionLink('Book a free 30-min call', cfg.bookingUrl, 'calendar_today', hot, extra);
      call.addEventListener('click', () => track('chat_cta_clicked', { cta: 'call' }));
      if (hot) links.unshift(call);
      else links.push(call);
    }
    wrap.append(...links);
    return wrap;
  };

  const scrollDown = () => {
    log.scrollTop = log.scrollHeight;
  };

  const renderReplies = () => {
    replies.replaceChildren(
      ...state.replies.map((label) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'md-chip';
        chip.textContent = label;
        chip.addEventListener('click', () => send(label));
        return chip;
      }),
    );
  };

  const renderAll = () => {
    log.replaceChildren(...state.messages.flatMap(nodesFor));
    if (state.finale) log.append(finale());
    renderReplies();
    contact.hidden = !state.contact || state.sent;
    composer.hidden = state.sent;
    handoffButton.hidden = state.sent;
    rendered = true;
    scrollDown();
  };

  let lastBotAt = Date.now();
  let lastTypedAt = 0;

  const say = (content, nextReplies = [], ai = false) => {
    lastBotAt = Date.now();
    const message = ai ? { role: 'assistant', content, ai: true } : { role: 'assistant', content };
    state.messages.push(message);
    state.replies = nextReplies;
    log.append(...nodesFor(message));
    renderReplies();
    save();
    scrollDown();
  };

  const typing = () => {
    const node = document.createElement('div');
    node.className = 'md-chat__msg md-chat__msg--bot md-chat__typing';
    node.setAttribute('aria-label', 'Typing');
    node.append(document.createElement('span'), document.createElement('span'), document.createElement('span'));
    log.append(node);
    scrollDown();
    return node;
  };

  const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const showContact = () => {
    if (state.sent) return;
    state.contact = true;
    state.replies = [];
    renderReplies();
    contact.hidden = false;
    save();
    scrollDown();
    track('chat_contact_shown', { mode: state.mode });
  };

  const nextStep = () => STEPS.find((step) => !state.slots[step.slot]);

  const askNext = () => {
    if (state.browsing) {
      showContact();
      return;
    }
    const step = nextStep();
    if (!step) {
      state.awaiting = '';
      say("Thanks, that's everything I need. Leave your name and email and the team will reply within 1 working day.");
      showContact();
      return;
    }
    state.awaiting = step.slot;
    say(step.text, step.replies);
  };

  const fillAwaiting = (text) => {
    const slot = state.awaiting;
    if (!slot) return '';
    const step = STEPS.find((item) => item.slot === slot);
    const chosen = step.replies.find((label) => label.toLowerCase() === text.toLowerCase());
    if (state.mode === 'ai' && !chosen) return '';
    if (slot === 'website' && /^skip$/i.test(text)) state.slots.website = 'skipped';
    else state.slots[slot] = (chosen || text).slice(0, 200);
    state.awaiting = '';
    return slot;
  };

  const scripted = async (text, filledEarlier = '') => {
    await pause(450);
    if (text.toLowerCase() === CARRY_ON.toLowerCase()) {
      askNext();
      return;
    }
    if (/^just reading$/i.test(text)) {
      state.slots.intent = 'Just browsing';
      state.browsing = true;
      say(`No problem, have a look around. If a question comes up, ask it here and ${owner} will see it.`, ['See prices', 'How the audit works', TALK]);
      return;
    }
    const canned = CANNED[text.toLowerCase()];
    if (canned) {
      say(canned, state.browsing ? ['See prices', 'How the audit works', TALK] : []);
      if (!state.browsing) askNext();
      return;
    }
    const filled = filledEarlier || fillAwaiting(text);
    if (filled === 'intent' && /just browsing/i.test(state.slots.intent)) {
      state.browsing = true;
      say(`No problem, have a look around. If a question comes up, ask it here and ${owner} will see it.`, ['See prices', 'How the audit works', TALK]);
      return;
    }
    if (!filled) {
      say("Thanks, I'll pass that to the team.");
    }
    askNext();
  };

  const ask = async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`${endpoint}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: state.messages.map(({ role, content }) => ({ role, content })),
          slots: state.slots,
          page: location.pathname,
          trigger: state.trigger,
          owner,
          owner_online: presence().online,
          owner_back: presence().back,
          page_kind: state.pageKind || 'default',
          page_title: state.pageTitle || '',
          session,
        }),
        signal: controller.signal,
      });
      if (!response.ok) return null;
      const data = await response.json();
      return data && typeof data.reply === 'string' && data.reply ? data : null;
    } catch (error) {
      return null;
    } finally {
      clearTimeout(timer);
    }
  };

  const send = async (raw) => {
    const text = String(raw || '').trim().slice(0, 500);
    if (!text || busy || state.sent) return;
    busy = true;
    state.replies = [];
    renderReplies();
    const message = { role: 'user', content: text };
    state.messages.push(message);
    log.append(bubble(message));
    scrollDown();
    save();
    if (state.messages.filter((item) => item.role === 'user').length === 1) track('chat_engaged', { trigger: state.trigger || 'launcher', mode: state.mode });

    const lower = text.toLowerCase();
    if (isPerson(lower)) {
      await pause(300);
      handoff();
      busy = false;
      return;
    }
    if (lower === EMAIL_INSTEAD) {
      await pause(300);
      say(`Sure. Leave your name and email and ${owner} will reply personally within 1 working day.`);
      showContact();
      busy = false;
      return;
    }
    if (lower === START_FRESH.toLowerCase() && state.welcome) {
      await pause(300);
      forget();
      state.welcome = false;
      state.slots = fresh().slots;
      const first = opener({ kind: state.pageKind, title: state.pageTitle });
      if (first && state.pageKind !== 'audit') say(`Sure, starting fresh. ${first.text}`, first.replies);
      else {
        state.awaiting = 'intent';
        say("Sure, starting fresh. What brings you to OVXS today?", STEPS[0].replies);
      }
      busy = false;
      return;
    }
    if (lower === FINE) {
      await pause(300);
      say("No problem. I'm here if you need me.");
      busy = false;
      setTimeout(() => close(), 1400);
      return;
    }

    let filled = '';
    if (state.mode === 'ai') {
      filled = fillAwaiting(text);
      const dots = typing();
      const data = await ask();
      dots.remove();
      if (data) {
        Object.entries(data.slots || {}).forEach(([key, value]) => {
          if (key in state.slots && typeof value === 'string' && value) state.slots[key] = value.slice(0, 200);
        });
        const facts = (state.slots.details || '').split(';').filter((part) => part.trim()).length;
        const known = state.slots.intent && facts >= 2 && state.slots.timeline && state.slots.budget && !/just browsing/i.test(state.slots.intent);
        const ready = data.collect_contact || (known && !state.contact && !state.declined);
        if (['hot', 'warm', 'cold'].includes(data.lead_score)) state.score = data.lead_score;
        remember(typeof data.project_summary === 'string' ? data.project_summary.trim() : '');
        const frustrated = data.offer_handoff === true || frustratedBy(text);
        let chips = Array.isArray(data.quick_replies) ? data.quick_replies.slice(0, 4) : [];
        if (frustrated) {
          chips = [TALK, ...chips.filter((chip) => !isPerson(chip.toLowerCase()))].slice(0, 4);
          track('chat_frustration', { model: data.offer_handoff === true });
        } else if (!ready && !state.contact && chips.length && !chips.some((chip) => isPerson(chip.toLowerCase()))) chips.push(TALK);
        say(data.reply, ready && !frustrated ? [] : chips, true);
        if (ready) showContact();
        busy = false;
        return;
      }
      state.mode = 'scripted';
      track('chat_fallback');
      save();
    }

    const dots = typing();
    await scripted(text, filled);
    dots.remove();
    busy = false;
  };

  const start = (intro) => {
    if (state.messages.length) return;
    const page = pageContext();
    state.pageKind = page.kind;
    state.pageTitle = page.title;
    if (intro === 'form_stalled') {
      say(FORM_HELP.text, FORM_HELP.replies);
      return;
    }
    const memory = page.kind === 'audit' ? null : recall();
    if (memory) {
      state.welcome = true;
      state.slots = { ...state.slots, ...memory.slots };
      say(`Welcome back. Still thinking about ${memory.summary}?`, [CARRY_ON, START_FRESH]);
      event('welcome_back');
      track('chat_welcome_back');
      return;
    }
    const first = opener(page);
    if (first) {
      say(first.text, first.replies);
      return;
    }
    state.awaiting = 'intent';
    say(STEPS[0].text, STEPS[0].replies);
  };

  const event = (type) => {
    fetch(`${endpoint}/chat/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        session,
        type,
        page: location.pathname,
        page_kind: state.pageKind || 'default',
        trigger: state.trigger,
        owner_online: presence().online,
        slots: state.slots,
        messages: state.messages.map(({ role, content }) => ({ role, content })),
      }),
    }).catch(() => {});
  };

  const nudge = () => {
    if (state.nudged || busy || state.sent || state.contact || !isOpen()) return;
    const last = state.messages[state.messages.length - 1];
    if (!last || last.role !== 'assistant' || !last.content.includes('?')) return;
    if (!state.messages.some((item) => item.role === 'user')) return;
    if (input.value.trim() || Date.now() - lastBotAt < 45000 || Date.now() - lastTypedAt < 45000) return;
    state.nudged = true;
    const chips = [EMAIL_CHIP, ...state.replies.filter((chip) => chip.toLowerCase() !== EMAIL_INSTEAD)].slice(0, 4);
    say(`No rush. You can also just leave your email and ${owner} will pick it up.`, chips);
    event('nudge');
    track('chat_stall_nudge');
  };
  setInterval(nudge, 5000);

  const isOpen = () => !panel.hidden;

  const open = ({ focus = true, trigger = '', animate = true } = {}) => {
    if (!rendered) renderAll();
    if (trigger && !state.trigger) state.trigger = trigger;
    root.classList.add('is-open');
    panel.hidden = false;
    launcher.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    if (animate) {
      panel.classList.add('is-entering');
      panel.addEventListener('animationend', () => panel.classList.remove('is-entering'), { once: true });
    }
    start(trigger);
    state.open = true;
    save();
    scrollDown();
    if (focus && !state.sent) input.focus({ preventScroll: true });
    if (phone.matches) document.documentElement.classList.add('md-chat-locked');
  };

  const close = () => {
    if (!isOpen()) return;
    const hadFocus = panel.contains(document.activeElement);
    root.classList.remove('is-open');
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    if (cfg.launcher !== 'true' && !state.messages.some((item) => item.role === 'user')) launcher.hidden = true;
    document.documentElement.classList.remove('md-chat-locked');
    state.open = false;
    save();
    if (!state.sent && !state.messages.some((item) => item.role === 'user')) {
      write('localStorage', KEY.dismissed, String(Date.now() + 7 * DAY));
      track('chat_dismissed', { trigger: state.trigger || 'launcher' });
    }
    if (hadFocus && !launcher.hidden) launcher.focus({ preventScroll: true });
  };

  const done = () => read('localStorage', KEY.done) === '1';

  const canAutoOpen = () => {
    if (isOpen() || state.sent || done()) return false;
    if (read('sessionStorage', KEY.shown) === '1') return false;
    if (Number(read('localStorage', KEY.dismissed) || 0) > Date.now()) return false;
    if (document.querySelector('dialog[open], html.md-pt-arriving')) return false;
    return true;
  };

  const autoOpen = (trigger) => {
    if (!canAutoOpen()) return;
    write('sessionStorage', KEY.shown, '1');
    if (phone.matches && cfg.mobileAuto !== 'true') {
      launcher.hidden = false;
      root.classList.add('is-nudged');
      track('chat_nudged', { trigger });
      return;
    }
    open({ focus: false, trigger });
    track('chat_auto_opened', { trigger }, { once: true });
  };

  launcher.addEventListener('click', () => {
    if (isOpen()) close();
    else {
      open({ trigger: 'launcher' });
      track('chat_opened', { trigger: 'launcher' });
    }
  });
  root.querySelector('[data-md-chat-close]').addEventListener('click', close);
  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      close();
    }
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-md-chat-open]');
    if (!trigger) return;
    event.preventDefault();
    open({ trigger: trigger.dataset.mdChatOpen || 'link' });
    track('chat_opened', { trigger: 'link' });
  });

  composer.addEventListener('submit', (event) => {
    event.preventDefault();
    const value = input.value;
    input.value = '';
    send(value);
  });
  input.addEventListener('input', () => {
    lastTypedAt = Date.now();
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      composer.requestSubmit();
    }
  });

  contact.querySelector('[data-md-chat-contact-cancel]').addEventListener('click', () => {
    state.contact = false;
    state.declined = true;
    contact.hidden = true;
    save();
    say('No problem. You can keep asking here, or book a video audit any time.', [TALK]);
  });

  contact.addEventListener('submit', async (event) => {
    event.preventDefault();
    const name = contact.elements.name.value.trim();
    const email = contact.elements.email.value.trim();
    contactError.hidden = true;
    if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      contactError.textContent = 'Please add your name and a valid email.';
      contactError.hidden = false;
      (name ? contact.elements.email : contact.elements.name).focus();
      return;
    }
    const button = contact.querySelector('[type="submit"]');
    button.disabled = true;
    let ok = false;
    try {
      const response = await fetch(`${endpoint}/chat/lead`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          name,
          email,
          slots: state.slots,
          messages: state.messages.map(({ role, content }) => ({ role, content })),
          mode: state.mode,
          trigger: state.trigger,
          page_url: location.origin + location.pathname,
          lead_score: state.score || '',
          owner_online: presence().online,
          session,
        }),
      });
      ok = response.ok;
    } catch (error) {}
    button.disabled = false;
    if (!ok) {
      contactError.textContent = "That didn't send. Please try again in a moment.";
      contactError.hidden = false;
      return;
    }
    state.sent = true;
    state.contact = false;
    state.name = name.split(/\s+/)[0];
    write('localStorage', KEY.done, '1');
    contact.hidden = true;
    composer.hidden = true;
    handoffButton.hidden = true;
    say(`Thanks, ${state.name}. ${owner} will reply to ${email} personally within 1 working day. ${state.score === 'cold' ? 'Meanwhile, have a look at some of our work:' : "If you'd like to move faster:"}`);
    state.finale = true;
    log.append(finale());
    save();
    scrollDown();
    track('generate_lead', { lead_type: 'chat', mode: state.mode }, { upgrade: true });
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_type: 'chat' });
  });

  const auditForm = document.querySelector('#OvxsAuditForm');
  if (document.querySelector('.md-audit__success')) write('localStorage', KEY.done, '1');

  let lastActivity = Date.now();
  const activity = () => {
    lastActivity = Date.now();
  };
  ['pointermove', 'pointerdown', 'keydown', 'scroll', 'touchstart', 'wheel'].forEach((type) =>
    window.addEventListener(type, activity, { passive: true, capture: true }),
  );

  let active = Number(read('sessionStorage', KEY.time) || 0);
  let pageActive = 0;
  let formStarted = false;
  let formSent = false;
  let lastFormInput = 0;

  if (auditForm) {
    const mark = () => {
      formStarted = true;
      lastFormInput = Date.now();
    };
    auditForm.addEventListener('input', mark);
    auditForm.addEventListener('focusin', mark);
    auditForm.addEventListener('submit', () => {
      formSent = true;
      write('localStorage', KEY.done, '1');
    });
  }

  const views = (() => {
    try {
      return JSON.parse(read('sessionStorage', KEY.views) || '{}');
    } catch (error) {
      return {};
    }
  })();
  const path = location.pathname.replace(/\/$/, '') || '/';
  views[path] = (views[path] || 0) + 1;
  write('sessionStorage', KEY.views, JSON.stringify(views));
  const pricingRevisit = cfg.intent === 'true' && /^\/pages\/(services|pricing)$/.test(path) && views[path] >= 2;
  const caseStudy = cfg.intent === 'true' && /case-study/.test(cfg.template);

  const engaged = () => active >= 15000;

  let hiddenAt = 0;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
      return;
    }
    if (idleMs && !auditForm && hiddenAt && Date.now() - hiddenAt >= idleMs && engaged()) autoOpen('returned');
    hiddenAt = 0;
    activity();
  });

  setInterval(() => {
    if (idleMs && !auditForm && document.visibilityState === 'visible' && Date.now() - lastActivity >= idleMs && engaged()) autoOpen('idle');
    if (document.visibilityState !== 'visible' || Date.now() - lastActivity > 30000) return;
    active += 1000;
    pageActive += 1000;
    if (active % 5000 === 0) write('sessionStorage', KEY.time, String(active));

    if (auditForm) {
      if (!formSent && formStarted && !auditForm.contains(document.activeElement) && Date.now() - lastFormInput >= 60000) autoOpen('form_stalled');
      if (!formSent && formStarted && auditForm.contains(document.activeElement) && Date.now() - lastFormInput >= 75000) autoOpen('form_stalled');
      return;
    }
    if (active >= delay) autoOpen('time');
    if (pricingRevisit && pageActive >= 8000) autoOpen('pricing_revisit');
  }, 1000);

  if (caseStudy && !auditForm) {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= 0.75) {
        window.removeEventListener('scroll', onScroll);
        autoOpen('case_study_read');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (cfg.intent === 'true' && !auditForm) {
    document.addEventListener('mouseout', (event) => {
      if (!finePointer.matches || event.relatedTarget || event.clientY > 0) return;
      if (active < 30000) return;
      autoOpen('exit_intent');
    });
  }

  const handoff = () => {
    const now = presence();
    track('chat_handoff', { online: now.online });
    event('handoff');
    if (now.online && (cfg.whatsapp || cfg.bookingUrl)) {
      const ways = cfg.whatsapp && cfg.bookingUrl ? 'Send a WhatsApp message or grab a time for a quick call' : cfg.whatsapp ? 'Send a WhatsApp message' : 'Grab a time for a quick call';
      const message = { role: 'assistant', content: `${owner}'s around now. ${ways}, whichever suits you.`, handoff: true };
      state.messages.push(message);
      state.replies = [EMAIL_CHIP];
      log.append(bubble(message), handoffLinks());
      renderReplies();
      save();
      scrollDown();
      return;
    }
    say(
      now.back
        ? `${owner}'s away right now and back ${now.back}. Leave your name and email and ${owner} will reply personally.`
        : `Leave your name and email and ${owner} will reply personally within 1 working day.`,
    );
    showContact();
  };

  const presenceText = root.querySelector('[data-md-chat-presence-text]');
  const renderPresence = () => {
    const now = presence();
    root.classList.toggle('is-online', now.online);
    if (presenceText) presenceText.textContent = now.text;
  };
  renderPresence();
  setInterval(renderPresence, 60000);

  handoffButton.addEventListener('click', () => {
    if (busy || state.sent) return;
    send(TALK);
  });

  const reveal = () => {
    root.hidden = false;
    if (cfg.launcher === 'true' || state.messages.some((item) => item.role === 'user')) {
      launcher.hidden = false;
      launcher.classList.add('is-entering');
    }
    if (state.open && !phone.matches) open({ focus: false, animate: false });
    if (new URLSearchParams(location.search).get('chat') === 'open') open({ trigger: 'url' });
  };

  if (document.documentElement.classList.contains('md-pt-arriving')) document.addEventListener('md:pt:done', reveal, { once: true });
  else setTimeout(reveal, 400);

  window.ovxsChat = { open: (trigger) => open({ trigger: trigger || 'api' }), close };
})();
